<template>
  <li class="nav__item">
    <router-link 
      v-if="menu.children === undefined && menu.route !== undefined"
      class="nav__item__link"
      :to="menu.route"
      :title="menu.title"
      :target="menu.target"
    >
      {{ menu.title }}
    </router-link>
    <a v-else-if="menu.children === undefined && menu.link !== undefined"
       class="nav__item__link" 
       :href="menu.link"
       :title="menu.title" 
       :for="menu.id"
       :target="menu.target"
    >
      {{ menu.title }}
    </a>
    <label v-else 
           class="nav__item__link" 
           href="#" 
           :title="menu.title" 
           :for="menu.id"
    >
      {{ menu.title }}
      <v-icon dark>menu</v-icon>
    </label>
  </li>
</template>
<script>

export default {
  name:'NavigationMainItem',
  props: {
    menu: {
      type: Object,
      required: true,
    },    
  },   
}

</script>

<style lang="scss" scoped>  
  // @import url('https://cdnjs.cloudflare.com/ajax/libs/normalize/8.0.1/normalize.css');

  // @import '@/sass/config.scss';  
  // @import '@/sass/base/mixins.scss';
  // @import '@/sass/components/nav/nav.scss';
  // @import '@/sass/components/nav/nav-logo.scss';
  // @import '@/sass/components/nav/nav-desktop.scss';
  // @import '@/sass/components/nav/nav-mobile.scss';
  // @import '@/sass/components/snackbar.scss';
 
 .nav__item__link{
   color:black;
 }
  
 .nav__mega__link__item{
   color:black;
 }
  
</style>